import { render, staticRenderFns } from "./access-forbidden.vue?vue&type=template&id=029286f0"
import script from "./access-forbidden.vue?vue&type=script&lang=ts"
export * from "./access-forbidden.vue?vue&type=script&lang=ts"
import style0 from "./access-forbidden.vue?vue&type=style&index=0&id=029286f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports